import Vue from 'vue'

const viewport = Vue.observable({
  height: 0
})

function update () {
  viewport.height = window.visualViewport
    ? window.visualViewport.height
    : window.innerHeight
}

export default () => {
  update()
  window.addEventListener('resize', update)

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', update)
  }
}

export { viewport }
